import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_PatientPortalConsentForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_PatientPortalConsentForm' className='file-pdf-document'>

            <div className='file-template'>
                <h3>PATIENT PORTAL CONSENT FORM
                </h3>
                <p>
                    By signing below, I authorize New Heights Behavioral Consultants to send email and text communications regarding the patient portal to the email address and phone numbers identified below and give my expressed consent for my medical information to be made available to me using myhealth.sharenote.com (NHBC's Electronic Medical Record). I understand that I have the right to receive a completed copy of this consent.
                </p>
                <p>
                    I understand that my health information is protected by federal and state law. This consent applies to records which may contain information related to the testing, diagnosis or treatment for conditions including, but not limit to, drug and alcohol abuse; psychotherapy, mental or other behavioral health; HIV/AIDS or other communicable diseases; genetic testing; or any other condition expressly protected by Georgia Law. This consent will remain in effect unless I deactivate my account or written notice is provided to New Heights Behavioral Consultants.
                </p>
                <p>
                    I understand that my username and password will be unique to my health information and sharing my username and password may grant others access to my health information. I further understand that any health information disclosed as a result of sharing my username and password may no longer be protected under federal or state law and could be further released by the individual who receives the information. I understand that I may refuse to sign this consent and such refusal will not prohibit me from receiving treatment.
                </p>
                <p>
                    I further understand that my refusal to sign this consent will not prevent me from receiving a copy of my medical records.
                </p>
                <p>
                    YES I do wish to access my medical information and give my expressed consent for New Heights Behavioral Consultants to make my medical information available to me using myhealth.sharenote.com (NHBC's Electronic Medical Record)
                </p>
                <table>
                    <tr>
                        <td className="signature w-350">&nbsp;</td>
                        <td className="signature w-300">&nbsp;</td>
                        <td className="signature w-100">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-350">Name of the Client (printed)</td>
                        <td className="small w-300">Signature</td>
                        <td className="small w-100">Date</td>
                    </tr>
                    <tr>
                        <td className="signature w-350">&nbsp;</td>
                        <td className="signature w-300">&nbsp;</td>
                        <td className="signature w-100">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-350">Parent or Legal Guardian (printed)</td>
                        <td className="small w-300">Signature</td>
                        <td className="small w-100">Date</td>
                    </tr>
                    <tr>
                        <td className="signature w-350">&nbsp;</td>
                        <td className="signature w-300">&nbsp;</td>
                        <td className="signature w-100">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-350">Staff (printed)</td>
                        <td className="small w-300">Signature w/ credentials</td>
                        <td className="small w-100">Date</td>
                    </tr>
                </table>
                <p>
                    USE THIS SPACE ONLY IF INDIVIDUAL SERVED/ PARENT/ LEGAL GUARDIAN WITHDRAWS CONSENT
                </p>
                <table>
                    <tr>
                        <td className="signature w-450">&nbsp;</td>
                        <td className="signature w-300">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-450">Signature of Individual Served/Parent/Legal Guardian</td>
                        <td className="small w-300">Date</td>
                    </tr>
                </table>

            </div>
        </form>

    )
}  